import LayoutMensagensEmbed from './componentes/LayoutMensagensEmbed.vue';
import Sessao from './componentes/Sessao.vue';
import CentralMensagens from './componentes/CentralMensagens.vue';
import AvisosMensagens from './componentes/AvisosMensagens.vue';

export default {
  path: '/central-mensagens',
  component: LayoutMensagensEmbed,
  children: [
    {
      path: '',
      name: 'central-mensagens.sessao',
      component: Sessao,
    },
    {
      path: 'lista',
      name: 'central-mensagens',
      component: CentralMensagens,
      props: { embutido: true },
    },
    {
      path: 'espera',
      name: 'central-mensagens.espera',
      component: { render: h => h('div') },
    },
    {
      path: 'conversa',
      name: 'central-mensagens.conversa',
      component: CentralMensagens,
      props: { embutido: true },
    },
    {
      path: 'avisos',
      name: 'central-mensagens.avisos',
      component: AvisosMensagens,
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/central-mensagens/rotas.js